(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-page-content"] && !Shopify.designMode) return;
  try {
    

      theme.AssetsLoader.onPageLoaded(function () {
                                  (function($){
                                    theme.dynamicCheckout.load(document.querySelector('[data-section-id="{{ section.id }}"] [data-js-product]'));
                                  })(jQueryTheme);
                                }, ['theme']);

  } catch(e) { console.error(e); }
})();
})();
